import {useMemo} from 'react';

import {
  makeVariableSlugFromCustomField,
  resourceTypeToRootField,
} from '../../../../helpers/customFieldHelpers';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {CustomFieldResourceTypesEnum} from '../../../../models/api/customFieldModel';
import {useSettingsCustomFields} from '../../../../settings/customFields/useCustomFields';
import {interpolationResourceTypes} from '../../../../store/data/customFields/customFieldsSelectors';
import {getHasCannedAnswersResourceCustomFields} from '../../../../store/featureFlags/featureFlagsSelectors';

export function useComposerCustomFieldVariables() {
  const customFields = useSettingsCustomFields();
  const hasResourceCustomFields = useAppSelector(getHasCannedAnswersResourceCustomFields);

  return useMemo(() => {
    const customFieldTypes = hasResourceCustomFields
      ? interpolationResourceTypes
      : [CustomFieldResourceTypesEnum.CARD];

    return customFieldTypes.flatMap((type) => {
      // TODO: Backfill templates and remove this.
      if (type === CustomFieldResourceTypesEnum.CARD) {
        return [
          ...customFields[type].map(makeVariableSlugFromCustomField),
          ...customFields[type].map(
            (customField) => `${resourceTypeToRootField(customField.resourceType)}.${customField.nameSlug}`,
          ),
        ];
      }

      return customFields[type].map(makeVariableSlugFromCustomField);
    });
  }, [hasResourceCustomFields, customFields]);
}
